// From MDN https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator

const getBrowser = (userAgent: string | undefined) => {
    if (!userAgent) return 'unknown';
    // The order matters here, and this may report false positives for unlisted browsers.
    if (userAgent.includes('Firefox')) {
        return 'Firefox';
    } else if (userAgent.includes('SamsungBrowser')) {
        return 'Samsung';
    } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
        return 'Opera';
    } else if (userAgent.includes('Edge') || userAgent.includes('Edg')) {
        return 'Edge';
    } else if (userAgent.includes('Chrome')) {
        return 'Chrome';
    } else if (userAgent.includes('Safari')) {
        return 'Safari';
    } else {
        return 'unknown';
    }
};

export default getBrowser;
